/* La puerta: entrar con usuario y contraseña, o elegir contraseña con el enlace de invitación.
   Sin correo ni registro público: las cuentas las crea David y cada uno elige la suya. */
import { useEffect, useState, type FormEvent } from 'react';
import { canjearInvitacion, entrar, infoInvitacion } from '../datos/sesion.ts';

function Marco({ children }: { children: React.ReactNode }) {
  return (
    <div className="app acceso-pagina" data-modo="tren">
      <div className="cielo" aria-hidden="true" />
      <main className="acceso">
        <p className="kicker"><span lang="ja">旅路</span> · JAPÓN 2026</p>
        <h1 className="acceso__titulo">Tabiji</h1>
        {children}
      </main>
    </div>
  );
}

export function Esperando() {
  return <Marco><p className="acceso__pie" role="status">Subiendo al tren…</p></Marco>;
}

export function Acceso() {
  const [usuario, setUsuario] = useState(''), [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null), [enviando, setEnviando] = useState(false);
  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    if (!usuario.trim() || !clave) return;
    setEnviando(true); setError(null);
    const r = await entrar(usuario, clave);
    setEnviando(false);
    if (r) { setError(r); setClave(''); }
  };
  return (
    <Marco>
      <form onSubmit={e => void enviar(e)} className="acceso__form">
        <label>Usuario<input name="usuario" autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} value={usuario} onChange={e => setUsuario(e.target.value)} autoFocus /></label>
        <label>Contraseña<input name="clave" type="password" autoComplete="current-password" value={clave} onChange={e => setClave(e.target.value)} /></label>
        {error && <p className="aviso" role="alert">{error}</p>}
        {!navigator.onLine && <p className="aviso">Sin conexión: para entrar hace falta red.</p>}
        <button type="submit" className="accion accion--ancha" disabled={enviando || !usuario.trim() || !clave}>{enviando ? 'Entrando…' : 'Entrar'}</button>
      </form>
      <p className="acceso__pie">¿Sin cuenta o con la contraseña olvidada? Pídele a David un enlace.</p>
    </Marco>
  );
}

export function Invitacion({ token }: { token: string }) {
  const [quien, setQuien] = useState<string | null | undefined>(undefined);
  const [clave, setClave] = useState(''), [repetida, setRepetida] = useState('');
  const [error, setError] = useState<string | null>(null), [enviando, setEnviando] = useState(false);
  useEffect(() => { void infoInvitacion(token).then(r => setQuien(r?.nombre ?? null)); }, [token]);
  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    if (clave !== repetida) { setError('Las dos contraseñas no coinciden'); return; }
    setEnviando(true); setError(null);
    const r = await canjearInvitacion(token, clave);
    setEnviando(false);
    if (r) { setError(r); return; }
    history.replaceState(null, '', location.pathname + location.search);   // el enlace ya no sirve: fuera de la barra
  };
  return (
    <Marco>
      {quien === undefined && <p className="acceso__pie" role="status">Mirando el enlace…</p>}
      {quien === null && <p className="aviso" role="alert">Este enlace ya no vale (se usó o caducó). Pídele a David uno nuevo.</p>}
      {quien && (
        <form onSubmit={e => void enviar(e)} className="acceso__form">
          <p className="texto">Hola, <b>{quien}</b>. Elige tu contraseña (mínimo 10 caracteres): solo la sabrás tú.</p>
          <label>Contraseña nueva<input name="clave" type="password" autoComplete="new-password" minLength={10} value={clave} onChange={e => setClave(e.target.value)} autoFocus /></label>
          <label>Repítela<input name="repetida" type="password" autoComplete="new-password" minLength={10} value={repetida} onChange={e => setRepetida(e.target.value)} /></label>
          {error && <p className="aviso" role="alert">{error}</p>}
          <button type="submit" className="accion accion--ancha" disabled={enviando || clave.length < 10}>{enviando ? 'Guardando…' : 'Guardar y entrar'}</button>
        </form>
      )}
    </Marco>
  );
}
